import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SiteSettings } from '../types';

interface ServicePageProps {
  settings: SiteSettings;
  title: string;
  h1: string;
  description: string;
  canonical: string;
  content: React.ReactNode;
  schema?: object;
}

const SEOPage: React.FC<ServicePageProps> = ({ settings, title, h1, description, canonical, content, schema }) => {
  return (
    <div className="bg-theme-bg pt-32 pb-24 transition-colors">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonical} />
        {schema && (
          <script type="application/ld+json">
            {JSON.stringify(schema)}
          </script>
        )}
      </Helmet>

      <section className="max-w-4xl mx-auto px-6">
        <span className="text-primary text-xs font-black uppercase tracking-[0.4em] mb-4 block">Gespecialiseerde Behandeling</span>
        <h1 className="font-display text-5xl md:text-7xl text-theme-text leading-tight mb-12">
          {h1}
        </h1>

        <div className="prose prose-lg prose-neutral dark:prose-invert max-w-none text-theme-muted font-light leading-relaxed space-y-8">
          {content}
          
          <div className="mt-16 bg-background-dark p-12 rounded-[3rem] text-center text-white border border-white/5">
            <h3 className="font-display text-3xl mb-6">Plan uw afspraak in Antwerpen</h3>
            <p className="mb-10 text-gray-400 max-w-xl mx-auto">
              Bij MD An De Cuyper bent u in veilige handen voor al uw esthetische wensen.
            </p>
            <a 
              href={settings.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-primary text-black px-12 py-5 rounded-2xl font-black uppercase tracking-widest text-xs hover:bg-white transition-all inline-block"
            >
              Maak een Afspraak
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SEOPage;
